const editVideoDataConstantsEn = {
  inventoryManagementNavBar: 'Inventory Management',
  editVideoDataPageTitle: 'Edit Video Information',
  editVideoDataSaveButton: 'Save Information',
  editVideoDataVideoTitleEn: 'Video Title (English)',
  editVideoDataVideoTitleAr: 'Video Title (Arabic)',
  editVideoDataVideoDescriptionEn: 'Video Description (English)',
  editVideoDataVideoDescriptionAr: 'Video Description (Arabic)',
  editVideoDataManageTagsText: 'Manage Video Metadata',
  editVideoDataEnglishGenreLabel: 'Genre (English)',
  editVideoDataArabicGenreLabel: 'Genre (Arabic)',
  editVideoDataDurationLabel: 'Duration',
  editVideoDataLocationLabel: 'Location',
  editVideoDataQualityLabel: 'Video Quality',
  editVideoDataYearLabel: 'Published Year',
  editVideoDataPriceLabel: 'Price',
  editVideoDataVideoDurationHours: 'Hours',
  editVideoDataVideoDurationMinutes: 'Minutes',
  editVideoDataVideoDurationSeconds: 'Seconds',
  editVideoDataVideoVideoTitleEmptyError: 'Video Title is required',
  editVideoDataVideoVideoSubtitleError: 'Video Subtitle is required',
  editVideoDataVideoVideoDescriptionError: 'Video Description is required',
  editVideoDataVideoGenreError: 'Genre is required',
  editVideoDataVideoCastError: 'Cast is required',
  editVideoDataVideoTagError: 'Tag is required',
  editVideoDataVideoFormatsError: 'Formats is required',
  editVideoDataVideoAvailabilityError: 'Availability is required',
  editVideoDataVideoIsRestrictedError: 'Restricted is required',
  editVideoDataVideoIsRushError: 'Rush / Non Rush is required',
  editVideoDataVideoLanguageError: 'Language is required',
  editVideoDataVideoDurationError: 'Duration is required',
  editVideoDataVideoQualityError: 'Quality is required',
  editVideoDataVideoYearError: 'Published Year is required',
  editVideoDataVideoPriceError: 'Price is required',
  editVideoDataDeleteChipDialogTitle: 'Delete',
  editVideoDataDeleteTagDialogContent: 'Are you sure you want to delete',
  editVideoDataEditBtn: 'Edit',
  editVideoDataDeleteBtn: 'Delete',
  editVideoDataAddBtn: 'Add',
  editVideoDataUpdateBtn: 'Update',
  editVideoDataCancelBtn: 'Cancel',
  editVideoDataAddNewGenreBtn: 'Add New Genre',
  editVideoDataAddNewTagBtn: 'Add New Tag',
  editVideoDataAddNewCastBtn: 'Add New Cast',
  editVideoDataGenresLabel: 'Genres',
  editVideoDataTagsLabel: 'Tags',
  editVideoDataCastLabel: 'Casts',
  editVideoDataAddNewRowBtn: 'Add New Row',
  editVideoDataFormatsLabel: 'Formats',
  editVideoDataAvailabilityLabel: 'Availability',
  editVideoDataIsRestrictedLabel: 'Restricted',
  editVideoDataIsRushLabel: 'Rush / Non Rush',
  editVideoDataRush: 'Rush',
  editVideoDataNonRush: 'Non Rush',
  editVideoDataLanguageLabel: 'Language',
  addChipDialogGenresTitle: 'Add new Genre',
  addChipDialogCastTitle: 'Add new Cast',
  addChipDialogTagsTitle: 'Add new Tag',
  addChipDialogEnglishChipLabel: 'English',
  addChipDialogArabicChipLabel: 'Arabic',
  addChipDialogAddButton: 'Add',
  editVideoDataExclusive: 'Exclusive',
  editVideoDataNonExclusive: 'Non Exclusive',
  editVideoDataRestricted: 'Restricted',
  editVideoDataNotRestricted: 'Not Restricted',
  editVideoDataLanguageArabic: 'Arabic',
  editVideoDataLanguageEnglish: 'English',
  editVideoDataLanguageBilingual: 'Bilingual',
  addChipDialogEnglishChipRequired: 'English is required',
  addChipDialogArabicChipRequired: 'Arabic is required',
  editVideoDataChipAlreadyExist: 'Already exist',
  editVideoDataReferenceId: 'Reference ID',
  editVideoDataBrightcoveId: 'Brightcove ID',
  editVideoDataCategoryLabel: 'Categories',
  editVideoDataCountryLabel: 'Countries',
  addChipDialogCategoryTitle: 'Add new Category',
  addChipDialogCountryTitle: 'Add new Country',
  editVideoDataVideoCategoryError: 'Categories is required',
  editVideoDataVideoCountryError: 'Countries is required',
  annual: 'Annual',
  unlimited: 'Unlimited',
  durationLicense: 'Duration License',
  editVideoDataVideoDemographicError: 'Demographic is required',
  demographicTitle: 'Demographics',
  editVideoDataVideoLicenseError: 'Duration License is required',
  updateDetails: 'Edit Video Information',
  quality: 'Quality',
  annualPrice: 'Annual Price',
  unlimitedPrice: 'Unlimited Price',
  actions: 'Actions',
  key: 'Key',
  value: 'Value',
  editVideoDataVideoRushDemographicError: 'Demographic is required',
  editVideoDataVideoTagsError: 'Tags is required',
  editVideoDataVideoLocationError: 'Location is required',
  editVideoDataVideoLanguageTypeError: 'Language is required',
  riyal_symbol: 'SAR',
  addChipDialogDemographicTitle: 'Add new demographic',
  priceIsRequired: 'Price is required',
  thisFieldIsRequired: 'This field is required',

  deleteVideoButton: 'Delete Video',
  deleteMediaDialogTitle: 'Confirm Deletion',
  deleteMediaDialogDescriptionP1: 'You are about to delete this media from the Sayma Marketplace. Please be aware that this action cannot be undone.',
  deleteMediaDialogDescriptionP2: 'Deleting this media will affect several areas, including wishlist, cart and Proposal Requests.',
  deleteMediaDialogDescriptionP3: 'This action may lead to the removal or alteration of related information in the above areas.',
  deleteMediaDialogConfirmationQuestion: 'Are you sure you want to proceed with the deletion?',
  deleteMediaDialogCancelButton: 'Cancel',
  deleteMediaDialogConfirmButton: 'Confirm Delete',
  mediaDeletedSuccessfully: 'Deleted Successfully',
  editVideoDataVideoReferenceIdField: 'ReferenceId is required',
  editVideoDataVideoBrightcoveIdField: 'BrightcoveId is required',
  editVideoDataVideoFileTypeField: 'FileType is required',
  editVideoDataOwnerLabel: 'Owner',
};

export default editVideoDataConstantsEn;
